import type VueRouter from 'vue-router';
import type { Store } from 'vuex';

import { baseContainer, BaseServiceTokens } from '@/di/container';

export const getBaseStore = () => baseContainer.resolve<Store<unknown>>(BaseServiceTokens.BaseStore);
export const getBaseRouter = () => baseContainer.resolve<VueRouter>(BaseServiceTokens.VueRouter);
